/* ==========================================================================
   TROUVER MA TAILLE — moteur commun
   Charge une fois, pilote tous les blocs .fq de la page.
   Toute la configuration vient des attributs data- du bloc.
   ========================================================================== */
(function(){
  function boot(root){
    if(!root || root.dataset.on) return;
    root.dataset.on = '1';

    var TABLE   = JSON.parse(root.dataset.table || '[]');
    var COLS    = JSON.parse(root.dataset.cols  || '[]');
    var FOOT    = root.dataset.foot    || '';
    var RULE    = root.dataset.rule    || '';
    var MEASURE = root.dataset.measure || 'body';
    var EASE    = parseFloat(root.dataset.ease || '0');
    var BIAS    = parseFloat(root.dataset.bias || '0');
    if(!TABLE.length) return;

  var DICT = {"fr":{"kicker":"Trouvez votre taille","btn":"Find your size","step":"Étape %s/6","q1":"Quelle taille portez-vous habituellement ?","skip":"Je ne connais pas ma taille","qb":"Quel est votre tour de poitrine ?","next":"Continuer","q2":"Portez-vous toujours cette taille ?","a2":["Non, je porte parfois plus petit","Oui","Non, je porte parfois plus grand"],"q3":"Quelle silhouette vous ressemble le plus ?","a3":["Ventre plat","Ventre moyen","Ventre arrondi"],"q4":"Comment décririez-vous votre carrure ?","a4":["Carrure fine","Carrure moyenne","Carrure large"],"q5":"Combien mesurez-vous ?","q6":"Quelle coupe préférez-vous pour cette pièce ?","a6":["Ajustée","Normale","Ample"],"calc":"Nous calculons votre taille","title":"Votre taille idéale","intro":"Nous avons fait le calcul et trouvé la taille qui vous correspond pour cette pièce.","introSwap":"D’après vos réponses, le %s serait votre taille, mais il n’est plus disponible.","warn":"Taille la plus proche encore disponible.","your":"VOTRE TAILLE","add":"Ajouter au panier","adding":"Ajout en cours…","redo":"Refaire le quiz","see":"Voir le tableau des mesures","reco":"Nous vous recommandons la taille %s","size":"Taille"},"en":{"kicker":"Take our Fit quiz","btn":"Find your size","step":"Step %s/6","q1":"What size do you usually wear?","skip":"I don’t know my size","qb":"What is your bust measurement?","next":"Next","q2":"Do you always wear this size?","a2":["No, I sometimes wear a smaller size","Yes","No, I sometimes wear a bigger size"],"q3":"What do you think is most like you?","a3":["Flat stomach","Average stomach","Rounded stomach"],"q4":"How would you describe your chest?","a4":["Slim","Average","Broad"],"q5":"How tall are you?","q6":"What fit would you prefer for this item?","a6":["Slim fit","Regular fit","Loose fit"],"calc":"Working out your size","title":"Your perfect fit could be","intro":"We have done the calculations and found your perfect fit for this item.","introSwap":"Based on your answers the %s would be your size, but it is no longer available.","warn":"Closest size still available.","your":"YOUR SIZE","add":"Add to cart","adding":"Adding…","redo":"Redo the quiz","see":"See the measurements table","reco":"We recommend size %s","size":"Size"},"de":{"kicker":"Finden Sie Ihre Größe","btn":"Find your size","step":"Schritt %s/6","q1":"Welche Größe tragen Sie normalerweise?","skip":"Ich kenne meine Größe nicht","qb":"Wie groß ist Ihr Brustumfang?","next":"Weiter","q2":"Tragen Sie immer diese Größe?","a2":["Nein, manchmal kleiner","Ja","Nein, manchmal größer"],"q3":"Was kommt Ihnen am nächsten?","a3":["Flacher Bauch","Normaler Bauch","Runder Bauch"],"q4":"Wie würden Sie Ihre Schulterbreite beschreiben?","a4":["Schmal","Normal","Breit"],"q5":"Wie groß sind Sie?","q6":"Welche Passform bevorzugen Sie?","a6":["Eng","Normal","Weit"],"calc":"Wir berechnen Ihre Größe","title":"Ihre ideale Größe","intro":"Wir haben gerechnet und die passende Größe für dieses Teil gefunden.","introSwap":"Nach Ihren Angaben wäre %s Ihre Größe, sie ist jedoch nicht mehr verfügbar.","warn":"Nächstliegende verfügbare Größe.","your":"IHRE GRÖSSE","add":"In den Warenkorb","adding":"Wird hinzugefügt…","redo":"Quiz wiederholen","see":"Maßtabelle ansehen","reco":"Wir empfehlen Größe %s","size":"Größe"},"es":{"kicker":"Encuentre su talla","btn":"Find your size","step":"Paso %s/6","q1":"¿Qué talla sueles llevar?","skip":"No sé mi talla","qb":"¿Cuál es tu contorno de pecho?","next":"Continuar","q2":"¿Siempre llevas esta talla?","a2":["No, a veces una más pequeña","Sí","No, a veces una más grande"],"q3":"¿Qué se parece más a ti?","a3":["Vientre plano","Vientre medio","Vientre redondeado"],"q4":"¿Cómo describirías tus hombros?","a4":["Estrechos","Medios","Anchos"],"q5":"¿Cuánto mides?","q6":"¿Qué ajuste prefieres para esta prenda?","a6":["Ajustado","Normal","Holgado"],"calc":"Calculando tu talla","title":"Tu talla ideal","intro":"Hemos hecho el cálculo y encontrado la talla que te corresponde para esta prenda.","introSwap":"Según tus respuestas, la %s sería tu talla, pero ya no está disponible.","warn":"Talla más cercana todavía disponible.","your":"TU TALLA","add":"Añadir al carrito","adding":"Añadiendo…","redo":"Repetir el test","see":"Ver la tabla de medidas","reco":"Te recomendamos la talla %s","size":"Talla"},"it":{"kicker":"Trova la tua taglia","btn":"Find your size","step":"Passo %s/6","q1":"Che taglia porti di solito?","skip":"Non conosco la mia taglia","qb":"Qual è il tuo girovita petto?","next":"Continua","q2":"Porti sempre questa taglia?","a2":["No, a volte una più piccola","Sì","No, a volte una più grande"],"q3":"Cosa ti somiglia di più?","a3":["Pancia piatta","Pancia media","Pancia arrotondata"],"q4":"Come descriveresti le tue spalle?","a4":["Strette","Medie","Larghe"],"q5":"Quanto sei alta?","q6":"Quale vestibilità preferisci per questo capo?","a6":["Aderente","Normale","Ampia"],"calc":"Stiamo calcolando la tua taglia","title":"La tua taglia ideale","intro":"Abbiamo fatto il calcolo e trovato la taglia giusta per questo capo.","introSwap":"Secondo le tue risposte la %s sarebbe la tua taglia, ma non è più disponibile.","warn":"Taglia più vicina ancora disponibile.","your":"LA TUA TAGLIA","add":"Aggiungi al carrello","adding":"Aggiunta…","redo":"Rifai il quiz","see":"Vedi la tabella delle misure","reco":"Ti consigliamo la taglia %s","size":"Taglia"},"pl":{"kicker":"Znajdź swój rozmiar","btn":"Find your size","step":"Krok %s/6","q1":"Jaki rozmiar zwykle nosisz?","skip":"Nie znam swojego rozmiaru","qb":"Jaki jest Twój obwód biustu?","next":"Dalej","q2":"Czy zawsze nosisz ten rozmiar?","a2":["Nie, czasem mniejszy","Tak","Nie, czasem większy"],"q3":"Co najbardziej Cię przypomina?","a3":["Płaski brzuch","Przeciętny brzuch","Zaokrąglony brzuch"],"q4":"Jak opisałabyś swoje ramiona?","a4":["Wąskie","Przeciętne","Szerokie"],"q5":"Ile masz wzrostu?","q6":"Jaki krój preferujesz?","a6":["Dopasowany","Normalny","Luźny"],"calc":"Obliczamy Twój rozmiar","title":"Twój idealny rozmiar","intro":"Obliczyliśmy i znaleźliśmy rozmiar odpowiedni dla tego produktu.","introSwap":"Na podstawie odpowiedzi Twoim rozmiarem byłby %s, ale nie jest już dostępny.","warn":"Najbliższy dostępny rozmiar.","your":"TWÓJ ROZMIAR","add":"Dodaj do koszyka","adding":"Dodawanie…","redo":"Powtórz quiz","see":"Zobacz tabelę rozmiarów","reco":"Polecamy rozmiar %s","size":"Rozmiar"},"pt":{"kicker":"Encontre o seu tamanho","btn":"Find your size","step":"Passo %s/6","q1":"Que tamanho costuma usar?","skip":"Não sei o meu tamanho","qb":"Qual é o seu contorno de peito?","next":"Continuar","q2":"Usa sempre este tamanho?","a2":["Não, às vezes um mais pequeno","Sim","Não, às vezes um maior"],"q3":"O que mais se parece consigo?","a3":["Barriga lisa","Barriga média","Barriga arredondada"],"q4":"Como descreveria os seus ombros?","a4":["Estreitos","Médios","Largos"],"q5":"Quanto mede?","q6":"Que caimento prefere para esta peça?","a6":["Justo","Normal","Solto"],"calc":"A calcular o seu tamanho","title":"O seu tamanho ideal","intro":"Fizemos o cálculo e encontrámos o tamanho certo para esta peça.","introSwap":"Pelas suas respostas o %s seria o seu tamanho, mas já não está disponível.","warn":"Tamanho mais próximo ainda disponível.","your":"O SEU TAMANHO","add":"Adicionar ao carrinho","adding":"A adicionar…","redo":"Refazer o quiz","see":"Ver a tabela de medidas","reco":"Recomendamos o tamanho %s","size":"Tamanho"},"ro":{"kicker":"Găsiți-vă mărimea","btn":"Find your size","step":"Pasul %s/6","q1":"Ce mărime purtați de obicei?","skip":"Nu îmi știu mărimea","qb":"Care este circumferința bustului?","next":"Continuă","q2":"Purtați mereu această mărime?","a2":["Nu, uneori mai mică","Da","Nu, uneori mai mare"],"q3":"Cu ce vă asemănați cel mai mult?","a3":["Abdomen plat","Abdomen mediu","Abdomen rotunjit"],"q4":"Cum v-ați descrie umerii?","a4":["Înguști","Medii","Lați"],"q5":"Ce înălțime aveți?","q6":"Ce croială preferați pentru acest articol?","a6":["Mulată","Normală","Lejeră"],"calc":"Vă calculăm mărimea","title":"Mărimea dumneavoastră ideală","intro":"Am făcut calculul și am găsit mărimea potrivită pentru acest articol.","introSwap":"Conform răspunsurilor, %s ar fi mărimea dumneavoastră, dar nu mai este disponibilă.","warn":"Cea mai apropiată mărime disponibilă.","your":"MĂRIMEA DUMNEAVOASTRĂ","add":"Adaugă în coș","adding":"Se adaugă…","redo":"Reia testul","see":"Vezi tabelul de măsuri","reco":"Vă recomandăm mărimea %s","size":"Mărime"},"tr":{"kicker":"Bedeninizi bulun","btn":"Find your size","step":"Adım %s/6","q1":"Genellikle hangi bedeni giyiyorsunuz?","skip":"Bedenimi bilmiyorum","qb":"Göğüs çevreniz nedir?","next":"Devam","q2":"Her zaman bu bedeni mi giyersiniz?","a2":["Hayır, bazen daha küçük","Evet","Hayır, bazen daha büyük"],"q3":"Size en çok hangisi benziyor?","a3":["Düz karın","Orta karın","Yuvarlak karın"],"q4":"Omuzlarınızı nasıl tanımlarsınız?","a4":["Dar","Orta","Geniş"],"q5":"Boyunuz kaç?","q6":"Bu ürün için hangi kalıbı tercih edersiniz?","a6":["Dar kalıp","Normal kalıp","Bol kalıp"],"calc":"Bedeniniz hesaplanıyor","title":"İdeal bedeniniz","intro":"Hesaplamayı yaptık ve bu ürün için size uygun bedeni bulduk.","introSwap":"Yanıtlarınıza göre bedeniniz %s olurdu, ancak artık mevcut değil.","warn":"Mevcut olan en yakın beden.","your":"BEDENİNİZ","add":"Sepete ekle","adding":"Ekleniyor…","redo":"Testi tekrarla","see":"Ölçü tablosunu görün","reco":"Size %s bedenini öneriyoruz","size":"Beden"},"ru":{"kicker":"Найдите свой размер","btn":"Find your size","step":"Шаг %s/6","q1":"Какой размер вы обычно носите?","skip":"Я не знаю свой размер","qb":"Каков ваш обхват груди?","next":"Далее","q2":"Вы всегда носите этот размер?","a2":["Нет, иногда меньше","Да","Нет, иногда больше"],"q3":"Что вам ближе всего?","a3":["Плоский живот","Средний живот","Округлый живот"],"q4":"Как бы вы описали свои плечи?","a4":["Узкие","Средние","Широкие"],"q5":"Какой у вас рост?","q6":"Какую посадку вы предпочитаете?","a6":["Облегающая","Обычная","Свободная"],"calc":"Подбираем ваш размер","title":"Ваш идеальный размер","intro":"Мы всё рассчитали и подобрали подходящий размер для этой вещи.","introSwap":"По вашим ответам ваш размер — %s, но его больше нет в наличии.","warn":"Ближайший доступный размер.","your":"ВАШ РАЗМЕР","add":"В корзину","adding":"Добавляем…","redo":"Пройти заново","see":"Таблица размеров","reco":"Мы рекомендуем размер %s","size":"Размер"}};

  /* langue : celle de la page Shopify, sinon celle du navigateur, sinon l'anglais */
  /* langue par defaut : anglais. data-lang (Shopify) ou la langue de la page
     prennent le dessus quand ils existent. */
  var lang = (root.dataset.lang || document.documentElement.lang || 'en').slice(0,2).toLowerCase();
  if(!DICT[lang]) lang = 'en';
  var T = DICT[lang] || DICT.en;
  function tr(s, v){ return String(s).replace('%s', v); }



  var ORDER = TABLE.map(function(r){ return r.s; });
  /* variantes : Shopify ecrit le JSON brut dans une balise script */
  var VARIANTS = [];
  try{
    var tag = root.querySelector('script.fq__data');
    var raw = tag ? JSON.parse(tag.textContent) : [];
    var si = parseInt(root.dataset.si, 10);
    var ci = parseInt(root.dataset.ci, 10);
    VARIANTS = raw.map(function(v){
      return {
        id:    v.id,
        size:  si >= 0 ? (v['option' + (si + 1)] || '') : '',
        color: ci >= 0 ? (v['option' + (ci + 1)] || '') : '',
        ok:    !!v.available
      };
    });
  }catch(e){ VARIANTS = []; }

  var state = {};
  var stack = [];
  var cur = 1;

  var overlay = root.querySelector('.fq__overlay');
  var body    = root.querySelector('.fq__body');
  var stepEl  = root.querySelector('.fq__step');
  var backBtn = root.querySelector('.fq__back');

  /* ---------- quelles tailles sont achetables dans la couleur choisie ---------- */
  function currentColor(){
    var sel = document.querySelector('form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"]');
    if(sel && sel.value){
      var v = VARIANTS.filter(function(x){ return String(x.id) === String(sel.value); })[0];
      if(v) return v.color;
    }
    return null;
  }
  function availableSizes(){
    var col = currentColor();
    var list = VARIANTS.filter(function(v){
      return v.ok && (!col || !v.color || v.color === col);
    }).map(function(v){ return (v.size||'').toUpperCase(); });
    var out = ORDER.filter(function(s){ return list.indexOf(s) !== -1; });
    if(!out.length) out = ORDER.filter(function(s){
      return VARIANTS.some(function(v){ return v.ok && (v.size||'').toUpperCase() === s; });
    });
    return out.length ? out : ORDER.slice();
  }

  /* ----------------------------- ecrans ----------------------------- */
  var IMG_BELLY = root.dataset.imgBelly || '';
  var IMG_CHEST = root.dataset.imgChest || '';

  /* trois panneaux dans une seule image : on en montre un tiers par bouton */
    function picChips(url, group, labels){
    if(!url) return null;
    var h = '<div class="fq__chips fq__chips--img">';
    [0, 50, 100].forEach(function(pos, i){
      h += '<button type="button" data-g="' + group + '" data-v="' + (i - 1) + '">'
         +   '<span class="fq__pic" style="background-image:url(' + url + ');'
         +   'background-position:' + pos + '% 0"></span>'
         +   '<span class="fq__cap">' + labels[i] + '</span>'
         + '</button>';
    });
    return h + '</div>';
  }

  function chips(opts, group, stack_, sizeRow){
    var cls = 'fq__chips' + (stack_ ? ' fq__chips--stack' : '') + (sizeRow ? ' fq__chips--size' : '');
    var h = '<div class="' + cls + '">';
    opts.forEach(function(o){
      h += '<button type="button" data-g="'+group+'" data-v="'+o.v+'">'+o.t+'</button>';
    });
    return h + '</div>';
  }

  var SCREENS = {
    1: function(){
      var sizes = ORDER.map(function(s){ return {t:s, v:s}; });
      return '<p class="fq__q">' + T.q1 + '</p>'
           + chips(sizes, 'usual', false, true)
           + '<button type="button" class="fq__link" data-skip="1">' + T.skip + '</button>';
    },
    '1b': function(){
      return '<p class="fq__q">' + T.qb + '</p>'
           + '<p class="fq__val" data-out="bust">90 cm</p>'
           + '<input type="range" class="fq__range" data-in="bust" min="74" max="118" step="1" value="90">'
           + '<button type="button" class="fq__pill" data-next="2">' + T.next + '</button>';
    },
    2: function(){
      return '<p class="fq__q">' + T.q2 + '</p>'
           + chips([{t:T.a2[0],v:-1},{t:T.a2[1],v:0},{t:T.a2[2],v:1}], 'always', true);
    },
    3: function(){
      return '<p class="fq__q">' + T.q3 + '</p>'
           + (picChips(IMG_BELLY, 'shape', T.a3)
              || chips([{t:T.a3[0],v:-1},{t:T.a3[1],v:0},{t:T.a3[2],v:1}], 'shape'));
    },
    4: function(){
      return '<p class="fq__q">' + T.q4 + '</p>'
           + (picChips(IMG_CHEST, 'part', T.a4)
              || chips([{t:T.a4[0],v:-1},{t:T.a4[1],v:0},{t:T.a4[2],v:1}], 'part'));
    },
    5: function(){
      return '<p class="fq__q">' + T.q5 + '</p>'
           + '<p class="fq__val" data-out="height">165 cm</p>'
           + '<input type="range" class="fq__range" data-in="height" min="145" max="190" step="1" value="165">'
           + '<button type="button" class="fq__pill" data-next="6">' + T.next + '</button>';
    },
    6: function(){
      return '<p class="fq__q">' + T.q6 + '</p>'
           + chips([{t:T.a6[0],v:-1},{t:T.a6[1],v:0},{t:T.a6[2],v:1}], 'fit', true);
    }
  };

  function render(n){
    cur = n;
    body.innerHTML = (SCREENS[n] || SCREENS[1])();
    var rg = body.querySelector('.fq__range');
    if(rg){
      var k = rg.dataset.in;
      if(state[k] !== undefined){
        rg.value = state[k];
        var o = body.querySelector('[data-out="' + k + '"]');
        if(o) o.textContent = state[k] + ' cm';
      }
      paint(rg);
    }
    backBtn.hidden = (stack.length === 0);
    var num = (n === '1b') ? 1 : n;
    stepEl.textContent = (n === 'res' || n === 'calc') ? '' : tr(T.step, num);
    if(n === 'res') stepEl.textContent = '';
  }

  function go(n){ stack.push(cur); render(n); }

  /* ------------------------- le calcul ------------------------- */
  function compute(){
    var avail = availableSizes();
    var anchor;

    if(state.usual && ORDER.indexOf(state.usual) !== -1){
      anchor = ORDER.indexOf(state.usual);
    } else {
      /* pas de taille habituelle : on passe par la mesure et le tableau */
      var b = state.bust || 90;
      var target = (MEASURE === 'garment') ? b + EASE : b;
      anchor = ORDER.length - 1;
      for(var i=0;i<TABLE.length;i++){
        if(TABLE[i].bust >= target){ anchor = i; break; }
      }
    }

    var score = anchor
      + (state.always || 0) * 0.5
      + (state.shape  || 0) * 0.35
      + (state.part   || 0) * 0.35
      + (state.fit    || 0) * 0.75;

    if(state.height >= 178) score += 0.2;
    if(state.height <= 158) score -= 0.15;

    /* Arbitrage de la categorie : il ne s'applique QUE si l'on tombe
       vraiment entre deux tailles, comme l'indique le guide papier.
       Sinon il ecraserait la coupe demandee par la cliente.          */
    var frac = score - Math.floor(score);
    if(frac > 0.33 && frac < 0.67) score += BIAS * 1.2;

    var idx = Math.max(0, Math.min(ORDER.length - 1, Math.round(score)));
    var want = ORDER[idx], out = want, swapped = false;

    if(avail.indexOf(want) === -1){
      var best = null, bd = 99;
      avail.forEach(function(s){
        var d = Math.abs(ORDER.indexOf(s) - idx);
        if(d < bd || (d === bd && ORDER.indexOf(s) > idx)){ bd = d; best = s; }
      });
      if(best){ out = best; swapped = true; }
    }
    return {size: out, wanted: want, swapped: swapped};
  }

  function tableHtml(match){
    var h = '<table class="fq__t"><thead><tr><th>' + T.size + '</th>';
    COLS.forEach(function(c){ h += '<th>' + c[1] + '</th>'; });
    h += '</tr></thead><tbody>';
    TABLE.forEach(function(r){
      h += '<tr class="' + (r.s === match ? 'on' : '') + '"><td>' + r.s + '</td>';
      COLS.forEach(function(c){
        var v = r[c[0]];
        h += '<td>' + (v === undefined || v === 0 ? '—' : String(v).replace('.', ',')) + '</td>';
      });
      h += '</tr>';
    });
    return h + '</tbody></table>';
  }

  var MEM = 'mr_fitquiz_v1';

  var DUREE = 10 * 60 * 1000;   /* la recommandation vit 10 minutes */

  function remember(){
    try{
      var o = {};
      for(var k in state) o[k] = state[k];
      o._t = Date.now();
      localStorage.setItem(MEM, JSON.stringify(o));
    }catch(e){}
  }
  function recall(){
    try{
      var raw = localStorage.getItem(MEM);
      if(!raw) return null;
      var o = JSON.parse(raw);
      if(!o || !(o.usual || o.bust)) return null;
      if(!o._t || Date.now() - o._t > DUREE){ localStorage.removeItem(MEM); return null; }
      return o;
    }catch(e){ return null; }
  }

  var trig = root.querySelector('.fq__trigger');
  var trigLabel = trig.querySelector('span');
  var defaultLabel = (trigLabel.textContent || '').trim() || T.btn;
  trigLabel.textContent = defaultLabel;
  var kick = root.querySelector('.fq__kicker');
  if(kick) kick.textContent = T.kicker;

  function showReco(size){
    trig.classList.add('is-reco');
    trigLabel.textContent = tr(T.reco, size);
  }
  function clearReco(){
    trig.classList.remove('is-reco');
    trigLabel.textContent = defaultLabel;
  }

  /* court temps de calcul avant de reveler la taille */
  function result(){
    cur = 'calc';
    backBtn.hidden = true;
    stepEl.textContent = '';
    body.innerHTML = '<div class="fq__calc">'
      + '<div class="fq__dots"><span></span><span></span><span></span></div>'
      + '<p class="fq__calctxt">' + T.calc + '</p></div>';
    setTimeout(reveal, 1100);
  }

  function reveal(){
    var r = compute();
    remember();
    showReco(r.size);

    var intro = r.swapped ? tr(T.introSwap, r.wanted) : T.intro;

    body.innerHTML = '<div class="fq__res">'
      + '<h3>' + T.title + '</h3>'
      + '<p class="fq__intro">' + intro + '</p>'
      + (r.swapped ? '<p class="fq__warn">' + T.warn + '</p>' : '')
      + '<p class="fq__lbl">' + T.your + '</p>'
      + '<p class="fq__size">' + r.size + '</p>'
      + '<button type="button" class="fq__pill" data-pick="' + r.size + '">' + T.add + '</button>'
      + '<button type="button" class="fq__redo">' + T.redo + '</button>'
      + '<details class="fq__det"><summary>' + T.see + '</summary>'
      + '<div class="fq__tw">' + tableHtml(r.size) + '</div>'
      + '<p class="fq__tn">' + FOOT + '<br>' + RULE + '</p>'
      + '</details></div>';

    backBtn.hidden = true;
    stepEl.textContent = '';
    cur = 'res';
  }

  /* --------------- selection de la variante dans le theme --------------- */
  function pick(size){
    var col = currentColor();
    var target = VARIANTS.filter(function(v){
      return (v.size||'').toUpperCase() === size.toUpperCase()
          && (!col || !v.color || v.color === col) && v.ok;
    })[0] || VARIANTS.filter(function(v){
      return (v.size||'').toUpperCase() === size.toUpperCase() && v.ok;
    })[0];

    var done = false;
    var up = size.toUpperCase();

    /* 1. le vrai bouton de taille du theme */
    var nodes = document.querySelectorAll(
      'form[action*="/cart/add"] input[type="radio"], [data-value], .swatch label, .variations__item label, li[data-value]'
    );
    Array.prototype.forEach.call(nodes, function(el){
      if(done) return;
      var val = (el.getAttribute && el.getAttribute('data-value')) || el.value || el.textContent || '';
      if(String(val).trim().toUpperCase() !== up) return;
      var inp = el.tagName === 'INPUT' ? el : el.querySelector('input');
      if(inp){ inp.checked = true; inp.dispatchEvent(new Event('change', {bubbles:true})); }
      if(el.click) el.click();
      done = true;
    });

    /* 2. a defaut, le select de variante */
    if(!done && target){
      var sel = document.querySelector('form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"]');
      if(sel){
        sel.value = String(target.id);
        sel.dispatchEvent(new Event('change', {bubbles:true}));
        done = true;
      }
    }
    return done;
  }

  /* ----------------------------- evenements ----------------------------- */
  trig.addEventListener('click', function(){
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    if(trig.classList.contains('is-reco')){
      stack = [];
      reveal();          /* on reaffiche la taille deja calculee */
    } else {
      state = {}; stack = [];
      render(1);
    }
  });

  function close(){ overlay.hidden = true; document.body.style.overflow = ''; }
  root.querySelector('.fq__x').addEventListener('click', close);
  overlay.addEventListener('click', function(e){ if(e.target === overlay) close(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !overlay.hidden) close(); });

  backBtn.addEventListener('click', function(){
    var prev = stack.pop();
    if(prev === undefined) return;
    render(prev);
  });

  function paint(el){
    var pct = (el.value - el.min) / (el.max - el.min) * 100;
    el.style.setProperty('--fq-fill', pct + '%');
  }

  body.addEventListener('input', function(e){
    var el = e.target.closest('[data-in]');
    if(!el) return;
    var k = el.dataset.in;
    state[k] = +el.value;
    var out = body.querySelector('[data-out="' + k + '"]');
    if(out) out.textContent = el.value + ' cm';
    paint(el);
  });

  body.addEventListener('click', function(e){
    var b = e.target.closest('button');
    if(!b) return;

    if(b.dataset.g){
      var v = b.dataset.v;
      state[b.dataset.g] = (b.dataset.g === 'usual') ? v : +v;
      if(b.dataset.g === 'usual')      go(2);
      else if(b.dataset.g === 'always') go(3);
      else if(b.dataset.g === 'shape')  go(4);
      else if(b.dataset.g === 'part')   go(5);
      else if(b.dataset.g === 'fit')  { stack.push(cur); result(); }
      return;
    }
    if(b.dataset.skip){ state.usual = null; go('1b'); return; }
    if(b.dataset.next){ go(+b.dataset.next); return; }
    if(b.dataset.pick){
      var ok = pick(b.dataset.pick);
      b.textContent = T.adding;
      b.disabled = true;
      /* on laisse le theme recalculer la variante, puis on declenche
         SON propre bouton d'ajout au panier : pas de panier parallele. */
      setTimeout(function(){
        var form = document.querySelector('form[action*="/cart/add"]');
        var add  = form && (form.querySelector('[type="submit"]')
                 || form.querySelector('.add-to-cart, .btn-addtocart, button[name="add"]'));
        close();
        b.textContent = T.add;
        b.disabled = false;
        if(add) add.click();
        else if(form) form.submit();
      }, ok ? 450 : 150);
      return;
    }
    if(b.classList.contains('fq__redo')){
      state = {}; stack = [];
      try{ localStorage.removeItem(MEM); }catch(e){}
      clearReco();
      render(1);
      return;
    }
  });

  /* ---- la cliente a deja fait le quiz : on recommande sans rien demander ---- */
  (function restore(){
    var saved = recall();
    if(!saved) return;
    state = saved;
    showReco(compute().size);

    /* quand les 10 minutes sont ecoulees, le bouton reprend son libelle */
    var reste = DUREE - (Date.now() - saved._t);
    setTimeout(function(){
      try{ localStorage.removeItem(MEM); }catch(e){}
      state = {};
      clearReco();
      if(cur === 'res' && !overlay.hidden) render(1);
    }, Math.max(1000, reste));
  })();

  /* ---------------------------------------------------------------
     On NE deplace PLUS le bouton dans le selecteur du theme.
     Kalles reconstruit ce selecteur des qu'une variante change ou
     qu'une taille est epuisee, et emportait le bouton avec lui.
     Le bouton reste donc dans son propre bloc, et on lui applique
     son style en ligne pour que le theme ne l'ecrase pas.
     --------------------------------------------------------------- */
  (function style(){
    var btn = root.querySelector('.fq__trigger');
    if(!btn) return;
    var dur = {
      'display':'inline-flex', 'align-items':'center', 'justify-content':'flex-start',
      'align-self':'flex-start', 'flex':'0 0 auto',
      'width':'auto', 'min-width':'0', 'max-width':'none',
      'height':'auto', 'min-height':'0',
      'gap':'9px', 'padding':'0', 'margin':'4px 0 10px',
      'background':'none', 'border':'0', 'border-radius':'0', 'box-shadow':'none',
      'color':'#111', 'font-family':'inherit', 'font-size':'16.5px', 'font-weight':'600',
      'line-height':'1.2', 'letter-spacing':'-.01em', 'text-transform':'none',
      'text-align':'left', 'cursor':'pointer'
    };
    for(var p in dur) btn.style.setProperty(p, dur[p], 'important');
    var sp = btn.querySelector('span');
    if(sp){
      sp.style.setProperty('text-decoration','underline','important');
      sp.style.setProperty('text-underline-offset','4px','important');
      sp.style.setProperty('text-decoration-thickness','2px','important');
      sp.style.setProperty('font-size','16.5px','important');
    }
  })();
}

  function start(){
    document.querySelectorAll('.fq').forEach(boot);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  /* l'editeur de theme recharge les blocs sans recharger la page */
  document.addEventListener('shopify:section:load', start);
})();